/**
 * Loading skeleton for {@link CommittedSearchField}.
 */

"use client";

import { Flex, Skeleton } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";

export interface CommittedSearchFieldSkeletonProps {
  minW?: string | number;
  maxW?: string | number;
  w?: string | number;
  "data-testid"?: string;
}

export function CommittedSearchFieldSkeleton({
  minW = "240px",
  maxW,
  w = "100%",
  "data-testid": dataTestId,
}: CommittedSearchFieldSkeletonProps) {
  const theme = useThemeTokens();

  return (
    <Flex
      h="44px"
      w={w}
      minW={minW}
      maxW={maxW}
      align="center"
      gap={2}
      pl={3}
      pr={1.5}
      borderWidth="1px"
      borderColor={theme.borderGlass.default}
      borderRadius="8px"
      bg="transparent"
      data-testid={dataTestId}
    >
      <Skeleton boxSize="16px" borderRadius="full" flexShrink={0} />

      <Skeleton flex={1} minW={0} height="14px" borderRadius="4px" />

      <Flex align="center" gap={1.5} flexShrink={0} w="108px" justify="flex-end">
        <Skeleton boxSize="32px" borderRadius="8px" />
        <Skeleton h="32px" w="72px" borderRadius="8px" />
      </Flex>
    </Flex>
  );
}
